module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_05-73c319a097748bfb7310e79120a76ba0.png";